module.exports = __webpack_public_path__ + "img/banner.efee9ca2.png";